import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  private pendingITREvent = new Subject<void>();
  pendingITREvent$ = this.pendingITREvent.asObservable();

   private annualTaxUploadedSource = new Subject<void>();
  annualTaxUploaded$ = this.annualTaxUploadedSource.asObservable();

  triggerAnnualTaxJsonEvent() {
    this.annualTaxUploadedSource.next();
  }

  triggerPendingITREvent() {
    this.pendingITREvent.next();
  }

}
